import { Action } from 'redux-act';
import { put, takeEvery } from 'redux-saga/effects';

import {
  menucategoriesSaveFailed,
  menucategoriesSaveSucceeded,
  saveMenuCategories,
  SaveMenuCategoriesPayload,
} from '../../actions/menucategories/saveMenuCategories';

function* saveMenuCategoriesSaga(saveMenuCategoriesAction: Action<SaveMenuCategoriesPayload>) {
  const { payload } = saveMenuCategoriesAction;
  const { data } = payload;
  const response = { error: undefined }; // <- change to `{ error: true }`, to view what happens on error

  if (!response.error) {
    const saveSucceededPayload = { data };
    const saveSucceededAction = menucategoriesSaveSucceeded(saveSucceededPayload);
    yield put(saveSucceededAction);
  } else {
    const saveFailedPayload = { data };
    const saveFailedAction = menucategoriesSaveFailed(saveFailedPayload);
    yield put(saveFailedAction);
  }
}

export default function* watchSaveMenuCategoriesSaga() {
  yield takeEvery(saveMenuCategories, saveMenuCategoriesSaga);
}
